import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAmericanFootball: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAmericanFootball"><Path d="M9.75 14.25L14.25 9.75M12.9815 2.98145L21 11M3 13L11 21M14.5 2.5H20.5C21.0523 2.5 21.5 2.94772 21.5 3.5V9.5C21.5 16.1274 16.1274 21.5 9.5 21.5H3.5C2.94771 21.5 2.5 21.0523 2.5 20.5V14.5C2.5 7.87258 7.87258 2.5 14.5 2.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAmericanFootball;
